import { render, staticRenderFns } from "./ListPosts.vue?vue&type=template&id=67381ef4"
import script from "./ListPosts.vue?vue&type=script&lang=js"
export * from "./ListPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67381ef4')) {
      api.createRecord('67381ef4', component.options)
    } else {
      api.reload('67381ef4', component.options)
    }
    module.hot.accept("./ListPosts.vue?vue&type=template&id=67381ef4", function () {
      api.rerender('67381ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/feed/ListPosts.vue"
export default component.exports